/** Hiring company offered by the Register dialog (a company the caller may hire into). */
export interface PacketRegistrationCompany {
  companyId: number;
  prCo: number;
  name: string;
}
